import React from "react";
import { DayliPlanContext } from "../context/dayliPlanContext";
import InputDate from "../../../../components/inputs/date/inputDate";
import IDayliPlan from "../interface/iDayliPlan";

const TillDateInput = (): React.JSX.Element => {
  const {
    isLoading,
    dayliPlan,
    setDayliPlan,
  }: {
    isLoading: boolean;
    dayliPlan: IDayliPlan;
    setDayliPlan: (dayliPlan: IDayliPlan) => void;
  } = React.useContext(DayliPlanContext);

  const onChangeHandler = (date: string): void =>
    setDayliPlan({ ...dayliPlan, tillDate: date });

  return (
    <InputDate
      label="Bis"
      disabled={isLoading}
      date={dayliPlan.tillDate}
      setDate={onChangeHandler}
    />
  );
};

export default TillDateInput;
